import { useCallback, useEffect, useState } from 'react';
import { getRepairWorkInProgressApi } from '@/api/bodyAndPaint';
import { RepairWorkInProgressResponse } from '@/types/api/bodyAndPaint';

interface GetRepairWorkInProgressDataHookProps {
  t_pm_car_inspection_id: number;
}
export const useGetRepairWorkInProgressData = ({
  t_pm_car_inspection_id,
}: GetRepairWorkInProgressDataHookProps) => {
  const [damagePartList, setDamagePartList] =
    useState<RepairWorkInProgressResponse>({} as RepairWorkInProgressResponse);

  const fetchDate = useCallback(async () => {
    try {
      if (t_pm_car_inspection_id > 0) {
        const fetch = await getRepairWorkInProgressApi({
          t_pm_car_inspection_id,
        });
        setDamagePartList(fetch?.data);
      } else {
        setDamagePartList({} as RepairWorkInProgressResponse);
        throw 'invalid parameter';
      }
    } catch (error) {
      console.error(error);
    }
  }, [t_pm_car_inspection_id]);
  useEffect(() => {
    fetchDate();
  }, [fetchDate]);

  return { damagePartList };
};
